/**
 * Returns CPF digits only, ignoring mask characters (. - / space).
 */
export const normalizeCpf = (cpf?: string | null): string | null => {
  if (!cpf) {
    return null;
  }

  return cpf.replace(/\D/g, "");
};
